var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.games),function(game){return _c('game-component',{key:game.name,attrs:{"item":game,"name":game.name,"logoPath":game.logoPath,"path":game.path}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }